import { AuthProvider } from "./AuthContext.js";
import { ProductosProvider } from "./provider/ProductosContext.js";
import { CategoriasProvider } from "./provider/CategoriasContext.js";
import { OrdenesProvider } from "./provider/OrdenesContext.js";
import { MesaProvider } from "./provider/MesaContext.js";
import { FacturasProvider } from "./provider/FacturasContext.js";
import { VentasProvider } from "./provider/VentasContext.js";
import { InventarioProvider } from "./provider/InventarioContext.js";
import { InventarioVentaProvider } from "./provider/InventarioVentaContext.js";
import { CajaSesionProvider } from "./provider/CajaSesionContext.js";
import { GastosProvider } from "./provider/GastosContext.js";
import { GastosCategoriasProvider } from "./provider/GastosCategoriasContext.js";
import { GastosxMetodoProvider } from "./provider/GastosVistasContext.js";
import { VentasxMetodoProvider } from "./provider/VentasVistasContext.js";
import { InventarioPeriodoProvider } from "./provider/InventarioPeriodosContext.js";
import { ProductosBomProvider } from "./provider/ProductosBomContext.js";
import { InventarioInicialProvider } from "./provider/InventarioInicialContext.js";
import { InventarioMovimientoProvider } from "./provider/InventarioMovimientoContext.js";

export const AppProviders = ({ children }) => (
  <AuthProvider>
    <InventarioMovimientoProvider>
      <InventarioInicialProvider>
        <ProductosBomProvider>
          <InventarioPeriodoProvider>
            <VentasxMetodoProvider>
              <GastosxMetodoProvider>
                <GastosCategoriasProvider>
                  <GastosProvider>
                    <CajaSesionProvider>
                      <InventarioVentaProvider>
                        <InventarioProvider>
                          <VentasProvider>
                            <OrdenesProvider>
                              <CategoriasProvider>
                                <ProductosProvider>
                                  <MesaProvider>
                                    <FacturasProvider>
                                      {children}
                                    </FacturasProvider>
                                  </MesaProvider>
                                </ProductosProvider>
                              </CategoriasProvider>
                            </OrdenesProvider>
                          </VentasProvider>
                        </InventarioProvider>
                      </InventarioVentaProvider>
                    </CajaSesionProvider>
                  </GastosProvider>
                </GastosCategoriasProvider>
              </GastosxMetodoProvider>
            </VentasxMetodoProvider>
          </InventarioPeriodoProvider>
        </ProductosBomProvider>
      </InventarioInicialProvider>
    </InventarioMovimientoProvider>
  </AuthProvider>
);
